import { render, staticRenderFns } from "./DettagliArchiviate.vue?vue&type=template&id=19d6d35d&"
import script from "./DettagliArchiviate.vue?vue&type=script&lang=js&"
export * from "./DettagliArchiviate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports